var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSystemmanagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#1f1f1f;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "abb_settings_32") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Box"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 32,
    height: 32
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Final_icons_-_Common",
    "data-name": "Final icons - Common"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M30,18V14l-3.35-.72a10.83,10.83,0,0,0-1.2-2.89l1.86-2.88L24.49,4.69,21.61,6.55a10.83,10.83,0,0,0-2.89-1.2L18,2H14l-.72,3.35a10.83,10.83,0,0,0-2.89,1.2L7.51,4.69,4.69,7.51l1.86,2.88a10.83,10.83,0,0,0-1.2,2.89L2,14v4l3.35.72a10.83,10.83,0,0,0,1.2,2.89L4.69,24.49l2.82,2.82,2.88-1.86a10.83,10.83,0,0,0,2.89,1.2L14,30h4l.72-3.35a10.83,10.83,0,0,0,2.89-1.2l2.88,1.86,2.82-2.82-1.86-2.88a10.83,10.83,0,0,0,1.2-2.89ZM16,21a5,5,0,1,1,5-5A5,5,0,0,1,16,21Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystemmanagement);
export default __webpack_public_path__ + "static/media/systemmanagement.6ceeb8f204ebc3432f5a33371511a254.svg";
export { ForwardRef as ReactComponent };